import { Flow, FlowRequest, FlowResponse, parseFlowResponse } from "@/types/app/flow";
import { AxiosPromise, AxiosResponse } from "axios";
import { ApiService } from "./api.service";

export const upsertFlow = async (request: FlowRequest): AxiosPromise<Flow> => {
  const response: AxiosResponse<FlowResponse> = await ApiService.post(`/v5/flows`, request);
  return { ...response, data: parseFlowResponse(response.data) };
};
